import { render, staticRenderFns } from "./configInfo.vue?vue&type=template&id=f223302a&scoped=true&"
import script from "./configInfo.vue?vue&type=script&lang=js&"
export * from "./configInfo.vue?vue&type=script&lang=js&"
import style0 from "./configInfo.vue?vue&type=style&index=0&id=f223302a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f223302a",
  null
  
)

export default component.exports